import { render, staticRenderFns } from "./view_file.vue?vue&type=template&id=072ccb9f&scoped=true&"
import script from "./view_file.vue?vue&type=script&setup=true&lang=ts&"
export * from "./view_file.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./view_file.vue?vue&type=style&index=0&id=072ccb9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ccb9f",
  null
  
)

export default component.exports